import { Icon, ICONS, mixins, Modal, styled } from '@bob/library'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import React, { FC, useState } from 'react'

import { Share } from './Share/Share'

const Wrapper = styled.div`
  display: flex;
  padding-bottom: 20px;
  @media print {
    display: none;
  }
`

const Item = styled.button`
  background-color: ${({ theme }) => theme.background.primary};
  ${mixins.typography.subtitleMedium};
  color: ${({ theme }) => theme.color.link};
  cursor: pointer;
  border: none;
  padding: 0;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  ${mixins.margin.right(30)}

  > svg {
    ${mixins.margin.right(10)}
    > path {
      fill: ${({ theme }) => theme.color.link};
    }
  }
`

export const PrintAndShare: FC<{ onPrint?: () => void; onShare?: () => void }> = ({
  onPrint,
  onShare,
}) => {
  const [shareModal, showShareModal] = useState(false)
  const t = useStaticText()

  return (
    <Wrapper>
      <Item
        onClick={() => {
          onPrint?.()
          window.print()
        }}
      >
        <Icon icon={ICONS.PRINT} size={20} />
        {t.print_and_share.print_button}
      </Item>
      <Item
        onClick={() => {
          onShare?.()
          showShareModal(!shareModal)
        }}
      >
        <Icon icon={ICONS.SHARE} size={20} />
        {t.print_and_share.share_button}
      </Item>
      {shareModal && (
        <Modal closeCallback={() => showShareModal(!shareModal)} position={'center'}>
          <Share url={window.location.href} />
        </Modal>
      )}
    </Wrapper>
  )
}
